import { differenceInSeconds, formatDuration, intervalToDuration } from "date-fns";

export default (targetTime) => ({
  timeRemaining: 0,
  intervalId: null,

  init() {
    this.startCountdown(targetTime);
  },

  startCountdown(targetTime) {
    const targetDate = new Date(targetTime);

    this.updateTime(targetDate);

    this.intervalId = setInterval(() => {
      this.updateTime(targetDate);
    }, 1000);
  },

  updateTime(targetDate) {
    this.timeRemaining = differenceInSeconds(targetDate, new Date());

    if (this.timeRemaining <= 0) {
      this.timeRemaining = 0;
      this.clearInterval();
    }
  },

  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  destroy() {
    this.clearInterval();
  },

  get formattedTime() {
    if (this.timeRemaining <= 0) {
      return formatDuration({ seconds: 0 });
    }

    const duration = intervalToDuration({
      start: 0,
      end: this.timeRemaining * 1000,
    });
    return formatDuration(duration);
  },

  get isFinished() {
    return this.timeRemaining <= 0;
  },
});
